import React, { useRef } from 'react';
import { useGetBrokerGroupsQuery } from '@/features/user/userApi';
import { Tooltip } from '@mui/material';
import { OverflowChips } from '@/components/OverflowChips';
import { useChipFit } from '@/hooks/useChipFit';

const DataGridMultiBrokerGroup = ({ brokerGroupIds, showAdmin, onClick, ...props }) => {
	const sx = props?.sx ?? {};

	const brokerGroupsQuery = useGetBrokerGroupsQuery(
		{ ids: brokerGroupIds, showAdmin },
		{
			skip: !brokerGroupIds?.length,
		},
	);

	const brokerGroups = (brokerGroupsQuery.data ?? []).filter((group) =>
		brokerGroupIds.includes(group.id),
	);

	const allNames = brokerGroups.map((group) => group?.name);

	const containerRef = useRef();
	const limitTags = useChipFit(containerRef, brokerGroups.length);

	return (
		<Tooltip title={allNames.join(', ')}>
			<OverflowChips
				ref={containerRef}
				items={brokerGroups}
				limitTags={limitTags}
				onClick={onClick}
				width='100%'
				height='100%'
				getLabel={(group) => group?.name ?? ''}
				{...{ sx }}
			/>
		</Tooltip>
	);
};
DataGridMultiBrokerGroup.displayName = 'DataGridMultiBrokerGroup';
export default DataGridMultiBrokerGroup;
